import api from '../index';

const baseUrl = '/coUser';

const gamiFiBaseUrl = '/users';

export const AddApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/add`,
    data,
  });
};

export const setupApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/setup-details`,
    data,
  });
};

export const VerifyCoUserAPI = (verificaionToken) => {
  return api({
    method: 'get',
    url: `${baseUrl}/verify-child-account?key=${verificaionToken}`,
  });
};

export const getAllMechanins = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-all-mechanics`,
  });
};

export const getUserApi = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-user`,
  });
};

export const updateUserApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update-user`,
    data,
  });
};

export const changePasswordApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/change-password`,
    data,
  });
};

export const updateWageRateApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update-wage-rate`,
    data,
  });
};

export const getAllUsersApi = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-all-users`,
  });
};

export const addUpdateGamificationDetailsApi = (data) => {
  return api({
    method: 'put',
    url: `${gamiFiBaseUrl}/gamification`,
    data,
  });
};

export const getGamificationDetailsApi = () => {
  return api({
    method: 'get',
    url: `${gamiFiBaseUrl}/gamification`,
  });
};

export const getAllCoUsers = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-all-co-users`,
  });
};

export const getServiceWritersApi = (page, search) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-service-writers?page=${page}&&search=${search}`,
  });
};

export const getTechnicianApi = (page, search) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-technicians?page=${page}&&search=${search}`,
  });
};
